const {
  DATAPLUS_ACTIONS_OVERALL,
  DATAPLUS_ACTIONS,
  DATAPLUS_ACTION_ESSENTIAL,
  DATAPLUS_ACTION_CORE,
  DATAPLUS_ACTION_EMBARGO,
  DATAPLUS_ACTION_FREE_EMBARGO,
  DATAPLUS_ACTION_CORE_EMBARGO,
  DATAPLUS_ACTION_ESSENTIAL_EMBARGO,
  DATAPLUS_ACTION_TABLEAU,
} = require("./constants");

const dataplusPermissions = (action, permissions, institutionId, year) => {
  const isReleaseOnly =
    permissions[institutionId].includes(`DATAPLUS_RELEASE_${year}`) &&
    !permissions[institutionId].some((item) =>
      [
        "DATAPLUS_ESSENTIAL_",
        "DATAPLUS_CORE_",
        "DATAPLUS_EMBARGO_",
        "DATAPLUS_ADVANCED_",
        "DATAPLUS_COMPREHENSIVE_",
      ].some((prefix) => item.startsWith(prefix)),
    );

  if (
    action === "dataplus:changePeers" &&
    permissions[institutionId].includes("DATAPLUS_CHANGE_PEERS")
  ) {
    return true;
  }

  // Prevents WUR Overview free users from seeing the wur pages
  if (isReleaseOnly && DATAPLUS_ACTIONS_OVERALL.includes(action)) {
    return false;
  }

  if (
    DATAPLUS_ACTIONS_OVERALL.includes(action) &&
    permissions[institutionId].some((item) =>
      [
        `DATAPLUS_RELEASE_${year}`,
        `DATAPLUS_ESSENTIAL_${year}`,
        `DATAPLUS_CORE_${year}`,
        `DATAPLUS_EMBARGO_${year}`,
        `DATAPLUS_ADVANCED_${year}`,
        `DATAPLUS_COMPREHENSIVE_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_ESSENTIAL.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_ESSENTIAL_${year}`].includes(item),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_CORE.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_CORE_${year}`].includes(item),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTIONS.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_ADVANCED_${year}`, `DATAPLUS_COMPREHENSIVE_${year}`].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_EMBARGO.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_ADVANCED_${year}`, `DATAPLUS_COMPREHENSIVE_${year}`].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_CORE_EMBARGO.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_CORE_${year}`].includes(item),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_ESSENTIAL_EMBARGO.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_ESSENTIAL_${year}`].includes(item),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_FREE_EMBARGO.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_RELEASE_${year}`].includes(item),
    )
  ) {
    return true;
  }

  if (
    action === "dataplus:export" &&
    permissions[institutionId].some((item) =>
      [
        `DATAPLUS_RELEASE_${year}`,
        `WUR_REPORTER_INTERIM_${year}`,
        `DATAPLUS_ESSENTIAL_${year}`,
        `DATAPLUS_ADVANCED_${year}`,
        `DATAPLUS_COMPREHENSIVE_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  if (
    DATAPLUS_ACTION_TABLEAU.includes(action) &&
    permissions[institutionId].some((item) =>
      [`DATAPLUS_COMPREHENSIVE_${year}`].includes(item),
    )
  ) {
    return true;
  }

  // Allows WUR Overview free users to access the insights preview page
  if (action === "dataplus:viewPageFree" && isReleaseOnly) {
    return true;
  }

  return false;
};

module.exports = {
  dataplusPermissions,
};
